import React, { useMemo } from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import { media } from "../../styles";
import {
  Grid,
  Section,
  Button,
  BreadCrumbBox,
  Typography,
  Card,
} from "../../core";
import { useSelector } from "react-redux";
import { useSizerData, parseSizerRates } from "../../hooks/useSizerData";
import { Link } from "react-router-dom";

const btnProps = {
  bg: "#FF5687",
  width: "155px",
  height: "30px",
  margin: "0px 0px 0px auto",
  fontSize: "16px",
  lineheight: "24px",
  weight: "600",
  color: "white",
};

const StyledBreadCrumb = styled(BreadCrumbBox)`
  margin: 0px;
  .m-sm--auto {
    ${media.mobile`margin:10px auto;`}
  }
`;

const YarnInStock = () => {
  useSizerData();
  const sizerList = useSelector((state) => state.sizer.sizer) || [];

  const yarnInStock = useMemo(() => {
    const items = [];
    sizerList.forEach((sizer) => {
      const rates = parseSizerRates(sizer);
      rates.forEach((rate, idx) => {
        items.push({
          key: `${sizer.sizer_id}-${idx}`,
          tittle: rate.quality || rate.yarn_quality || `Quality ${idx + 1}`,
          value: rate.rate || rate.value || rate.count || "-",
          sizerId: sizer.sizer_id,
        });
      });
    });
    return items;
  }, [sizerList]);

  return (
    <Grid>
      <Section padding="20px" className="mt-50 mb-50">
        <StyledBreadCrumb tittle="Sizer Rates">
          <Link to="/sizer-list">
            <Button {...btnProps} className="m-sm--auto">
              Sizer List
            </Button>
          </Link>
        </StyledBreadCrumb>
      </Section>
      <Section className="mt-20" padding="20px">
        <Typography as="h3" color="#233B67" align="center" weight="bold">
          Yarn in Stock
        </Typography>
        <Row type="flex" justify="center" gutter={[16, 16]}>
          {yarnInStock.length ? (
            yarnInStock.map((items) => (
              <Col xl={6} sm={12} key={items.key}>
                <Card tittle={items.tittle} value={items.value} />
              </Col>
            ))
          ) : (
            <Col span={24}>
              <Typography align="center" text="No yarn quality rates found. Add sizers with quality rates." />
            </Col>
          )}
        </Row>
      </Section>
    </Grid>
  );
};

export default YarnInStock;
